export default __webpack_public_path__ + "static/media/Portal_Landing.9e62957b.png";